import Button from '@liquidweb-dev/undercurrent/Button';
import EmptyState, {
	type EmptyStateProps,
} from '@liquidweb-dev/undercurrent/EmptyState';
import SearchIcon from '@liquidweb-dev/undercurrent/icons/lucide/Search';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

export interface EmptyFilteredProps extends EmptyStateProps {
	onClearFilters: () => void;
}

const EmptyFiltered = ({ sx, onClearFilters, ...rest }: EmptyFilteredProps) => {
	return (
		<EmptyState
			icon={
				<SearchIcon
					sx={{
						height: ({ size }) => size.md,
						width: ({ size }) => size.md,
					}}
				/>
			}
			primaryButton={<Button onClick={onClearFilters}>Clear filters</Button>}
			sx={combineSx({ maxWidth: '264px' }, sx)}
			{...rest}
		>
			It looks like no items match those filters
		</EmptyState>
	);
};

export default EmptyFiltered;
